module.exports = __webpack_public_path__ + "img/tips-footer.27459437.jpg";